import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterEscrowAgreementPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='escrow_agreement_general'
        title='Escrow Agreement'
        activeTab='escrowAgreement'
        navConfig={null}
      />
    )
  }
}

export default MasterEscrowAgreementPageSF
